import React, { useContext, useMemo } from 'react';
import Typography from 'kingpin/atoms/Typography';
import styled from 'styled-components';
import Icon from '../kingpin/atoms/Icon';
import Row from './Common/Row';
import Inputs from './Inputs';
import Tooltip from './Tooltip';
import ConfigureGadgetBonusPeriodInfo from './ConfigGadgetBonusPeriodInfo';
import { UIVersionContext } from '../contextProviders/SplashScreenProviders/UserAndAccountProviders/UIVersionProvider';
import { V3SelectedAppContext } from '../contextProviders/SplashScreenProviders/UserAndAccountProviders/V3AppsProvider';
import appNavItemTypeCheckers from '../types/appNavItemTypeCheckers';

const Wrapper = styled.div`
  svg {
    cursor: help;
  }
`;

const BonusPeriodModeToggle = ({
  isBonusPeriodMode,
  onIsBonusPeriodModeChanged,
  selectedBonusPeriod,
}: {
  isBonusPeriodMode: boolean;
  onIsBonusPeriodModeChanged: (newStatus: boolean) => void;
  selectedBonusPeriod?: BonusPeriod | BonusTypes.BonusPeriod;
}) => {
  const { isV3 } = useContext(UIVersionContext);
  const { selectedProductApp } = useContext(V3SelectedAppContext);

  const appHasBonusPicker = useMemo(() => {
    if (!selectedProductApp) {
      return false;
    }
    return selectedProductApp.navigationSettings.sections.some((section) =>
      section.items.some(appNavItemTypeCheckers.isBonusPicker),
    );
  }, [selectedProductApp]);

  if (isV3 && !appHasBonusPicker) {
    return null;
  }

  return (
    <Wrapper>
      <Row centerAlign>
        <div style={{ marginRight: 8 }}>
          <Inputs.Toggle
            value={isBonusPeriodMode}
            onChange={onIsBonusPeriodModeChanged}
          />
        </div>
        <div style={{ marginRight: 8 }}>
          <Typography.Body type="Label">
            Use Driver Bonus Period
          </Typography.Body>
        </div>

        <Tooltip
          isAltTooltip
          content={
            <ConfigureGadgetBonusPeriodInfo
              selectedBonusPeriod={selectedBonusPeriod}
            />
          }
        >
          <Icon
            icon={'info'}
            color={'var(--color-grey-3)'}
            height={14}
            width={14}
          />
        </Tooltip>
      </Row>
    </Wrapper>
  );
};

export default BonusPeriodModeToggle;
